module.exports = __webpack_public_path__ + "static/media/coppe.403ccbcc.svg";